import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface CheckPaymentSectionProps {
  voucherCode: string;
  onVoucherChange: (value: string) => void;
}

const CheckPaymentSection: React.FC<CheckPaymentSectionProps> = ({
  voucherCode,
  onVoucherChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onVoucherChange(e.target.value);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputField
        label="Número de Cheque"
        name="checkVoucher"
        iconKey="payment" // puedes cambiar el iconKey si tienes uno específico para cheques
        type="text"
        placeholder="Ingrese el número de cheque"
        value={voucherCode}
        onChange={handleChange}
      />
    </div>
  );
};

export default CheckPaymentSection;
